<template>
  <ThuHoiTatCaDialog
    :widthDialog="'450px'"
    :classDialog="'refuse-dialog'"
    :isOpen="isOpen"
    :vbIncomingDocId="vbIncomingDocId"
    :dialogTitle="'Thu hồi về chờ tiếp nhận'"
    @closeDialog="$emit('closeDialog')"
    @dialogClosed="$emit('dialogClosed')"
    @save="save"
  >
  </ThuHoiTatCaDialog>
</template>

<script>
import incomingDocService from "../../../services/incomingDocService";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import {EventBus} from "../../../event-bus";


export default {
  name: "ThuHoiTatCaVanThuDialog",
  mixins: [handleRequestErrorMixin],
  props: ["vbIncomingDocId", "isOpen"],
  components: {
    ThuHoiTatCaDialog: () => import('../../doc-in/components/thuHoiTatCaVTDialog')
  },
  computed: {

    parentRoute() {
      return this.$route.path.split("/")[3];
    },
  },
  methods: {

    handleRequestError(error) {
      console.log(error)
      switch (error.errorCode) {
        case "vbIncomingDoc.thuHoi.statusNotMatch":
          this.$message({message: "Trạng thái văn bản không hợp lệ", type: 'error'});
          return true;
        case "vbIncomingDoc.thuHoi.nextProcessStatusMissMatch":
          this.$message({message: "Không thể thu hồi do văn bản đã được chuyển xử lý", type: 'error'});
          return true;
        case "vbIncomingDoc.thuHoi.toDeptIdMissMatch":
          this.$message({message: "Bạn không có quyền thực hiện thao tác này", type: 'error'});
          return true;
      }
      return false;
    },

    save(event) {
      incomingDocService
        .thuHoiSuper({comment: event.form.comment, listProcessId: event.form.listProcessId}, this.vbIncomingDocId)
        .then(response => {
          this.$message({message: 'Thu hồi văn bản thành công', type: 'success'});
          this.$emit("success", {vbIncomingDoc: response.data});
          EventBus.$emit('loadCounting', '');
        })
        .catch((error) => console.log("error: " + error));
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/thuHoiTatCaVanThuDialog.vue